import * as React from 'react';
import { View } from 'react-native';

import { Text } from '@/components/ui/text';
import { SetupLayout } from '@/features/setup/components/setup-layout';
import { useSetupContext } from '@/features/setup/setup-provider';

const STEP = 6;

export function CompletionScreen() {
  const { complete, goBack, isAdvancing, error } = useSetupContext();

  return (
    <SetupLayout
      step={STEP}
      onBack={goBack}
      primaryLabel="Let's go!"
      onPrimary={complete}
      primaryLoading={isAdvancing}
    >
      <View className="flex-1 items-center justify-center">
        <View className="items-center">
          <Text className="mb-2 text-3xl font-bold text-foreground">You&apos;re all set!</Text>
          <Text className="text-center text-base text-muted-foreground">
            You&apos;re ready to start exploring dishes near you.
          </Text>
        </View>

        {/* A failed completion stays on this screen rather than parking the user
            somewhere the retry is unreachable, so the reason belongs here. */}
        {error !== null && (
          <View
            testID="setup-completion-error"
            accessibilityRole="alert"
            className="mt-8 w-full rounded-lg border border-destructive/40 bg-destructive/10 p-4"
          >
            <Text className="text-center text-sm text-destructive">
              We could not finish setting up your account. {error.message}
            </Text>
            <Text className="mt-1 text-center text-sm text-muted-foreground">
              Check your connection and try again.
            </Text>
          </View>
        )}
      </View>
    </SetupLayout>
  );
}
